'use client';

import { useFlag } from '@unleash/nextjs';
import type { ReactNode } from 'react';
import { MAINTENANCE_FLAG } from './const';
import { MaintenancePage } from './MaintenancePage';
import { useHealthCheck } from './useHealthCheck';

export interface MaintenanceGateProps {
  children: ReactNode;
}

export const MaintenanceGate = ({ children }: MaintenanceGateProps) => {
  const isForcedByFlag = useFlag(MAINTENANCE_FLAG);
  const { isNotOk } = useHealthCheck();

  return isForcedByFlag || isNotOk ? <MaintenancePage /> : children;
};
